// src/App.js
import React from 'react';
import MyBook from './MyBook';

function App() {
  return (
    <div className="App">
      <MyBook />
    </div>
  );
}

export default App;
